module.exports = "/_next/static/images/CallToAction-f7b85b82bc4c63e218d2e02924d95031.svg";